'use strict';

const Alchemy = require('./Alchemy');
const ArmorUse = require('./ArmorUse');
const BowUse = require('./BowUse');
const Conjuration = require('./Conjuration');
const Illusion = require('./Illusion');
const MeleeCombat = require('./MeleeCombat');
const Movement = require('./Movement');
const Spirit = require('./Spirit');
const StandardAbilityTree = require('./StandardAbilityTree');

const ability_trees = {
  alchemy: Alchemy,
  armor_use: ArmorUse,
  bow_use: BowUse,
  conjuration: Conjuration,
  illusion: Illusion,
  melee_combat: MeleeCombat,
  movement: Movement,
  spirit: Spirit,
  standard: StandardAbilityTree,
};
module.exports = ability_trees;
